import { heroKeywords, heroStats, hotBoardData } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section id="latest" className="relative w-full overflow-hidden bg-background-50">
      <div
        className="pointer-events-none absolute right-0 top-0 hidden h-[520px] w-[46%] bg-cover bg-center opacity-[0.14] lg:block"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Abstract%20stylized%20watermelon%20inspired%20artwork%20with%20deep%20green%20curved%20fields%20and%20crimson%20red%20ripples%2C%20soft%20grainy%20texture%2C%20muted%20cream%20accents%2C%20blurred%20organic%20shapes%2C%20calm%20editorial%20poster%20style%2C%20low%20contrast%2C%20no%20text%2C%20harmonious%20composition&width=1200&height=900&seq=xg-hero-texture-01&orientation=landscape')",
          maskImage: 'linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0))',
          WebkitMaskImage: 'linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0))',
        }}
      ></div>

      <div className="relative px-4 pb-14 pt-14 md:px-6 md:pb-24 md:pt-24">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-start lg:gap-16">
          <div className="w-full lg:w-[62%]">
            <div className="flex flex-wrap items-center gap-2">
              <span className="flex items-center gap-1.5 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 font-label text-xs text-primary-700">
                <i className="ri-chat-smile-2-line text-sm"></i>
                圈内讨论型索引站
              </span>
              <span className="rounded-full border border-accent-200 bg-accent-50 px-3 py-1 font-label text-xs text-accent-700">
                热帖爆料 · 一网看尽
              </span>
            </div>

            <h2 className="mt-6 font-heading text-[34px] font-black leading-[1.18] tracking-tight text-foreground-950 md:text-[56px]">
              热搜上的瓜，
              <span className="relative inline-block">
                <span className="relative z-10">按索引一次看全</span>
                <span className="absolute inset-x-0 bottom-1.5 z-0 h-3 bg-accent-200/70 md:h-4"></span>
              </span>
            </h2>

            <p className="mt-6 max-w-2xl font-label text-[15px] leading-relaxed text-foreground-700 md:text-base">
              这里主打<span className="font-medium text-primary-700">西瓜黑料最新</span>和
              <span className="font-medium text-primary-700">合集</span>
              ，把圈内热帖和爆料按索引整理，点击就能围观热搜上的大瓜，
              想查的详情和进度都能顺着合集一路翻到底。
            </p>

            <div className="mt-7 flex flex-wrap gap-1.5">
              {heroKeywords.map((word) => (
                <span
                  key={word}
                  className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 font-label text-xs text-secondary-900 md:text-sm"
                >
                  #{word}
                </span>
              ))}
            </div>

            <div className="mt-9 flex flex-col gap-3 sm:flex-row">
              <a
                href="#latest-feed"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <i className="ri-flashlight-line text-base"></i>
                逛最新爆料
              </a>
              <a
                href="#hot"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3.5 font-label text-sm font-medium text-foreground-900 transition-colors hover:border-accent-300 hover:text-accent-700 cursor-pointer"
              >
                <i className="ri-fire-line text-base"></i>
                看今天热帖榜
              </a>
            </div>

            <div className="mt-12 grid grid-cols-2 gap-x-6 gap-y-7 border-t border-background-200 pt-8 sm:grid-cols-4">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <p className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                    {stat.value}
                  </p>
                  <p className="mt-1 font-label text-sm text-foreground-700">{stat.label}</p>
                  <p className="mt-0.5 font-label text-xs text-foreground-500">{stat.hint}</p>
                </div>
              ))}
            </div>
          </div>

          <aside className="w-full lg:w-[38%]">
            <div className="rounded-lg border border-background-200 bg-background-100/70 p-5 md:p-6">
              <div className="flex items-center justify-between">
                <p className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <i className="ri-flashlight-fill text-accent-500"></i>
                  热帖榜速览
                </p>
                <span className="flex items-center gap-1.5 font-label text-xs text-foreground-500">
                  <span className="h-1.5 w-1.5 animate-live-dot rounded-full bg-accent-500"></span>
                  滚动更新
                </span>
              </div>
              <ul className="mt-5 space-y-4">
                {hotBoardData.slice(0, 4).map((item) => (
                  <li key={item.id} className="flex items-start gap-3">
                    <span
                      className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-xs font-black ${
                        item.rank <= 3
                          ? 'bg-accent-500 text-background-50'
                          : 'bg-background-300/70 text-foreground-700'
                      }`}
                    >
                      {item.rank}
                    </span>
                    <div className="min-w-0">
                      <p className="truncate font-label text-sm text-foreground-900">{item.title}</p>
                      <p className="mt-1 flex items-center gap-2 font-label text-xs text-foreground-500">
                        <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
                          {item.tag}
                        </span>
                        <span>热度 {item.heat}</span>
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
              <a
                href="#hot"
                className="mt-5 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-primary-200 bg-primary-50 py-2.5 font-label text-sm text-primary-700 transition-colors hover:bg-primary-100 cursor-pointer"
              >
                查看完整榜单
                <i className="ri-arrow-right-line text-base"></i>
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}